"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isNil_1 = __importDefault(require("lodash/isNil"));
const filter_1 = require("ol/format/filter");
const WFS_1 = __importDefault(require("ol/format/WFS"));
/**
 * Helper class for building filters to be used with WFS GetFeature requests.
 *
 * @class WfsFilterUtil
 */
class WfsFilterUtil {
    /**
     * Creates a filter for a given feature type considering configured
     * search attributes, mapped features types to an array of attribute details and the
     * current search term.
     * Currently, supports EQUALTO and LIKE filters only, which can be combined with
     * OR filter if searchAttributes array contains multiple values though.
     *
     * @param {string} searchTerm Search value.
     * @param attributeDetails
     *   attributes that should be searched through.
     * @return {OlFormatFilter} Filter to be used with WFS GetFeature requests.
     * @private
     */
    static createWfsFilter(featureType, searchTerm, attributeDetails) {
        const details = attributeDetails[featureType];
        if (!details) {
            return null;
        }
        const attributes = Object.keys(details);
        if (attributes.length === 0) {
            return null;
        }
        const propertyFilters = attributes
            .filter(attribute => {
            const filterDetails = details[attribute];
            const type = filterDetails.type;
            return !(type && (type === 'int' || type === 'number') && searchTerm.match(/[^.\d]/));
        })
            .map(attribute => {
            var _a;
            const filterDetails = details[attribute];
            if (filterDetails.exactSearch) {
                return (0, filter_1.equalTo)(attribute, searchTerm, filterDetails.exactSearch);
            }
            else {
                return (0, filter_1.like)(attribute, `*${searchTerm}*`, '*', '.', '!', (_a = filterDetails.matchCase) !== null && _a !== void 0 ? _a : false);
            }
        });
        if (Object.keys(propertyFilters).length > 1) {
            return (0, filter_1.or)(...propertyFilters);
        }
        else {
            return propertyFilters[0];
        }
    }
    /**
     * Creates GetFeature request body for all provided featureTypes and
     * applies related filter encoding on it.
     *
     * @param {SearchConfig} searchConfig The search config
     * @param {string} searchTerm Search string to be used with filter.
     */
    static getCombinedRequests(searchConfig, searchTerm) {
        const { featureNS, featurePrefix, featureTypes, geometryName, maxFeatures, outputFormat, srsName, attributeDetails, propertyNames } = searchConfig;
        const requests = featureTypes === null || featureTypes === void 0 ? void 0 : featureTypes.map((featureType) => {
            const filter = WfsFilterUtil.createWfsFilter(featureType, searchTerm, attributeDetails);
            const wfsFormatOpts = {
                featureNS,
                featurePrefix,
                featureTypes: [featureType],
                geometryName,
                maxFeatures,
                outputFormat,
                srsName
            };
            if (!(0, isNil_1.default)(propertyNames)) {
                wfsFormatOpts.propertyNames = propertyNames;
            }
            if (!(0, isNil_1.default)(filter)) {
                wfsFormatOpts.filter = filter;
            }
            const wfsFormat = new WFS_1.default(wfsFormatOpts);
            return wfsFormat.writeGetFeature(wfsFormatOpts);
        });
        if ((0, isNil_1.default)(requests)) {
            return;
        }
        const request = requests[0];
        requests.forEach((req, idx) => {
            if (idx !== 0 && req.querySelector('Query')) {
                request.appendChild(req.querySelector('Query'));
            }
        });
        return request;
    }
}
exports.default = WfsFilterUtil;
